import { StockOrder, StockOrderStatus } from '../entity'

const paidStatuses = [
  StockOrderStatus.FULFILLED,
  StockOrderStatus.PENDING_EXECUTION_COMPLETION,
  StockOrderStatus.PENDING_SHARE_ISSUANCE,
]

export const isStockOrderPaid = (stockOrder: Partial<StockOrder>) => paidStatuses.includes(stockOrder.status)
